/**
 * Wishlist Hero PDP: sets --wlh-product-wishlist-icon-color on the container + inner div
 * so .wishlisthero-product-page-button-container > div::before/::after get dashboard background-color.
 * The app block often mounts after DOMContentLoaded — we observe body + load + polling.
 */
(function () {
  function isUsableColor(c) {
    if (!c || typeof c !== 'string') return false;
    var t = c.trim().toLowerCase();
    return t !== '' && t !== 'none' && t !== 'transparent' && t !== 'rgba(0, 0, 0, 0)';
  }

  /** Parse `color:` from a raw style attribute (WLH sometimes applies before .style is populated). */
  function colorFromStyleAttr(el) {
    if (!el || !el.getAttribute) return '';
    var s = el.getAttribute('style');
    if (!s) return '';
    var m = s.match(/(?:^|;)\s*color\s*:\s*([^;!]+)/i);
    return m ? m[1].trim() : '';
  }

  function pickWlhDashboardIconColor(host, svg, path, outer) {
    var c;
    c = colorFromStyleAttr(host);
    if (isUsableColor(c)) return c;
    if (host.style && host.style.color) {
      c = host.style.color.trim();
      if (isUsableColor(c)) return c;
    }
    if (svg) {
      c = colorFromStyleAttr(svg);
      if (isUsableColor(c)) return c;
      c = svg.getAttribute('color');
      if (isUsableColor(c)) return c.trim();
      if (svg.style && svg.style.color) {
        c = svg.style.color.trim();
        if (isUsableColor(c)) return c;
      }
    }
    c = getComputedStyle(host).color;
    if (isUsableColor(c)) return c;
    if (svg) {
      c = getComputedStyle(svg).color;
      if (isUsableColor(c)) return c;
      c = getComputedStyle(svg).fill;
      if (isUsableColor(c) && c !== 'none') return c;
    }
    if (path) {
      c = getComputedStyle(path).fill;
      if (isUsableColor(c) && c !== 'none') return c;
    }
    if (outer) {
      c = colorFromStyleAttr(outer);
      if (isUsableColor(c)) return c;
      c = getComputedStyle(outer).color;
      if (isUsableColor(c)) return c;
    }
    return '';
  }

  function getInnerWrap(container) {
    var wrap = container.firstElementChild;
    if (wrap && wrap.tagName === 'DIV') return wrap;
    try {
      wrap = container.querySelector(':scope > div');
    } catch (e) {
      wrap = null;
    }
    if (wrap) return wrap;
    return container.querySelector('div');
  }

  function applyIconColor(container, wrap, c) {
    if (!isUsableColor(c)) return;
    var targets = [container, wrap].filter(Boolean);
    targets.forEach(function (el) {
      try {
        el.style.setProperty('--wlh-product-wishlist-icon-color', c, 'important');
        el.style.setProperty('color', c, 'important');
      } catch (e) {
        el.style.setProperty('--wlh-product-wishlist-icon-color', c);
        el.style.color = c;
      }
    });
  }

  function wlhProductWishlistIconColor() {
    var list = document.querySelectorAll(
      '.wishlisthero-product-page-button-container, #wishlisthero-product-page-button-container'
    );
    list.forEach(function (container) {
      var wrap = getInnerWrap(container);
      var btn = container.querySelector('button');
      if (!btn) return;
      var svg = btn.querySelector('svg');
      var path = svg ? svg.querySelector('path') : null;
      var c = pickWlhDashboardIconColor(btn, svg, path, container);
      if (!isUsableColor(c)) return;
      if (wrap) applyIconColor(container, wrap, c);
      else applyIconColor(container, null, c);
    });
  }

  var debounceTimer;
  function debouncedSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(wlhProductWishlistIconColor, 50);
  }

  var bodyObsStarted;
  function observeBodyForWlh() {
    if (bodyObsStarted) return;
    var root = document.body;
    if (!root) return;
    bodyObsStarted = true;
    new MutationObserver(debouncedSync).observe(root, { childList: true, subtree: true });
  }

  function observeExistingContainers() {
    document
      .querySelectorAll('.wishlisthero-product-page-button-container, #wishlisthero-product-page-button-container')
      .forEach(function (container) {
        if (container.dataset.wlhNostebarnAttrObs) return;
        container.dataset.wlhNostebarnAttrObs = '1';
        new MutationObserver(debouncedSync).observe(container, {
          attributes: true,
          subtree: true,
          attributeFilter: ['style', 'class', 'color'],
        });
      });
  }

  function kick() {
    wlhProductWishlistIconColor();
    observeExistingContainers();
    observeBodyForWlh();
    requestAnimationFrame(wlhProductWishlistIconColor);
    requestAnimationFrame(function () {
      requestAnimationFrame(wlhProductWishlistIconColor);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kick);
  else kick();

  window.addEventListener('load', function () {
    wlhProductWishlistIconColor();
    observeExistingContainers();
  });

  var poll = setInterval(function () {
    wlhProductWishlistIconColor();
    observeExistingContainers();
  }, 400);
  setTimeout(function () {
    clearInterval(poll);
  }, 10000);

  setTimeout(wlhProductWishlistIconColor, 200);
  setTimeout(wlhProductWishlistIconColor, 800);
  setTimeout(wlhProductWishlistIconColor, 2000);
  setTimeout(wlhProductWishlistIconColor, 4000);

  document.addEventListener('shopify:section:load', function () {
    setTimeout(kick, 50);
  });
})();
